import { render, staticRenderFns } from "./RentalPinelYieldCard.vue?vue&type=template&id=656a6ef9&"
import script from "./RentalPinelYieldCard.vue?vue&type=script&lang=js&"
export * from "./RentalPinelYieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports